import { getAtPath, setAtPath } from './path';
import { getProviderOverrideConfig, getProviderPrimaryContentKey } from './provider-override-registry';
export function mergeProviderPreview({ body, providerId, override, }) {
    const config = getProviderOverrideConfig(providerId);
    const merged = { ...(override ?? {}) };
    const seed = config?.seedWhenAbsent;
    // Array-shaped content (LINE `messages`) — seed from the body only when the override omits
    // that key as an array, matching the send path that skips the default text message.
    if (seed) {
        if (Array.isArray(merged[seed.key])) {
            return { merged };
        }
        return {
            merged: {
                ...merged,
                [seed.key]: seed.buildDefault(body),
            },
            defaultContentKey: seed.defaultContentKey,
        };
    }
    const primaryKey = getProviderPrimaryContentKey(providerId);
    if (!primaryKey) {
        return { merged };
    }
    if (!getAtPath(merged, primaryKey)) {
        return { merged: setAtPath(merged, primaryKey, body), defaultContentKey: primaryKey };
    }
    return { merged };
}
/** @deprecated Renamed to `mergeProviderPreview`. */
export const mergeToolProviderPreview = mergeProviderPreview;
//# sourceMappingURL=merge-provider-preview.js.map